import { defineStore, } from "pinia";

export type TToastStatus = "success" | "warning" | "error" | "information";

interface IToast {
  text: string;
  description: string;
  status: TToastStatus;
  id: number;
  active: boolean;
}
type ToastPayload = { timeout?: number; text: string; description: string; };

const defaultTimeout = 3000;

const createToast = (text: string, description: string, status: TToastStatus): IToast => ({
  text,
  description,
  status,
  id: Math.random() * 1000,
  active: true
});

export const useToasterStore = defineStore("toaster-store", {
  state: (): { toasts: IToast[] } => ({ toasts: [] }),
  actions: {
    updateState(payload: ToastPayload, status: TToastStatus) {
      const { text, description, timeout } = payload;

      const toast = createToast(text, description, status);

      this.toasts.push(toast);

      setTimeout(() => {
        this.toasts = this.toasts.filter((t) => t.id !== toast.id);
      }, timeout ?? defaultTimeout);
    },
    remove(id: number) {
      let index = -1;
      let i = 0;

      for( let t of this.toasts){
        if(t.id==id){
          index = i;
        }
        i+=1;
      }
      if(index != -1){
        this.toasts.splice(index, 1);
      }
    },
    success(payload: ToastPayload) {
      this.updateState(payload, "success");
    },

    warning(payload: ToastPayload) {
      this.updateState(payload, "warning");
    },

    error(payload: ToastPayload) {
      this.updateState(payload, "error");
    },
  },
});